/**
 * Created by prakash on 22/9/18.
 */

import {ApplicationListPage} from "./applicationList-page";

/**
 * An array of data with an associated page object used for paging
 */
export class ApplicationListPageData<T> {
    data = new Array<T>();
    page = new ApplicationListPage();
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/system-level-setting/applicationManagement/applicationList-datatable/applicationList-page-data.ts